var jQuery=$=require('jquery');
    module.exports = {
       // props: ['hotelId'],
        data:function(){
            return {
            	id: '',
                param:'',
                url:this.baseApiPath,
                user:localStorage['username'],
                tagLib: [],
                num:'',
                tagshow:[],
                addTagtype:'',
                addTagName:'',
                isconfirm:false,
                speicalService: [],
                tags: []
             }
        },
        //计算属性
         computed:{
            serviceTag:function(){
                //var design=[];
                //console.log(this.tagLib)
               return this.tags.filter(function(x){
                  // return x.type==amenity
                //  console.log(x)
                  return x.type=="service"
                })
            },
            tagsId:function(){
                return this.tags.map(function(x){
                    return x.id
                })
            }
        },
         attached:function(){
            var that=this;
            $('.container-fluid').on('change','input',function(){
                that.isconfirm=true;
            });
            $('.container-fluid').on('change','textarea',function(){
                that.isconfirm=true;
            });
              
        },
        ready:function(){
            this.param = this.$route.params.id;
              if (this.param) {
                this.method = 'amenserv_update_service';
                this.id = this.param;
                var jqPromise = $.post(this.url, {
                    method: 'amenserv_service',
                    token: localStorage['token'],
                    hotel: this.param
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || this.param;
                    that.tags=value.data&&value.data.tags||[];
                    that.speicalService = value.data&&value.data.services || [{
                        name: '',
                        hotel:'',
                        pic:'http://ptkfile.feekr.com/activity/114/banner02.jpg',
                        text:'',
                    }]
                    // that.speicalService.push({
                    //     name: '',
                    //     hotel:'',
                    //     pic:'',
                    //     text:''
                    // })
                    console.log(value);
                    return value;
                })
            }
        },
        methods: {
             uploadhandle:function(e){
                var that=this;
                 var fileList = e.target.files;
                //console.log(files)
                var reader=new FileReader();
              //  console.log(that.num)
                if(fileList[0]&& fileList[0].type&& fileList[0].type.match('image.*')){
                    reader.readAsDataURL(fileList[0]);
                  }
                reader.onload = (function(file){
                    return function(e){
                      //  console.log(that.num)
                       var dataURL = reader.result;
                         var data = {
                                method: 'picture_upload',
                                token: localStorage['token'],
                                file: dataURL,
                                name:fileList[0].name
                            }
                            var jqPromise = $.post(that.baseApiPath, data);
                            var realPromise = Promise.resolve(jqPromise);
                            realPromise.then(function(value){
                                var value= JSON.parse(value);
                                that.speicalService[that.num].pic=value.data.file
                            }) 
                    }
                // console.log(reader.result)
                // console.log(dataURL)

                //  var output = document.getElementById('output');
                // for(var item in input.files){

                  // }
                 //  var str = "<img data-id='123145' src='"+dataURL+"'>";
                 //  $('#output').append(str);
                 // console.log(str)
                 //  output.src = dataURL;
                })(fileList[0])
            },
           uploadpic :function(num){
            this.num=num;
           // console.log(num)
            $('.deshandle:eq('+num+')').trigger('click');
           },
        	 addSpeicalService: function() {
                if (this.speicalService.length <= 5) {
                    var that = this;
                    var p1 = new Promise(function(resolve, reject) {
                        resolve('success')
                    })
                    p1.then(function(value) {
                        that.speicalService.push({
                            name: '',
                            hotel:'',
                            pic:'',
                            text:'',
                        });
                        return value;
                    })
                    // .then(function(value) {
                    //     $('.designernote').summernote({
                    //         height: 180
                    //     });
                    // })

                } else {
                    alert('最多只能添加6个服务')
                }
            },
            removespecial:function(n){
                this.speicalService.splice(n,1)
                this.isconfirm=true;
            },
            showTags: function(type,tags) {
                //design
                this.addTagtype=type
                var tagPromise = $.post(this.url, {
                    method: 'tag_types',
                    token: localStorage['token'],
                    types: type,
                    tags: 1
                });
                var tagsPromise = Promise.resolve(tagPromise),
                    that = this;
                tagsPromise.then(function(value) {
                   // console.log(value)
                    var value = JSON.parse(value);
                    that.tagLib = value.data&&value.data[0].tags;
                    //console.log(that.tagLib)
                })
                  .then(function(value){
                  //  console.log(tags)
                  that.tagshow=[];
                  that.tagshow.length=that.tagLib.length;
                for(j in that.tagLib){
                    for(i in tags){
                        if(that.tagLib[j].id==tags[i].id){
                            that.tagshow[j]=1;
                          //  console.log(that.tagLib[j])
                        }
                    }
                }
               // console.log(that.tagshow)
                })
            },
            addTohotel:function(num,dom){
               // console.log(this.tags)
                     this.tags.push(this.tagLib[num])
                      this.tagshow[num]=1;
                     console.log(this.tagshow.toString())
                    this.isconfirm=true;
            },
            addTag:function(){
                var promise=$.post(this.url,{
                    method:'tag_create',
                    token:localStorage['token'],
                    type:this.addTagtype,
                    name:this.addTagName
                })
                var addtagPromise=Promise.resolve(promise),
                that=this;
                addtagPromise.then(function(value){
                    var value=JSON.parse(value);
                    if(value.code==0){
                        that.tagLib.push(value.data);
                        that.tags.push(value.data)
                       // console.log(that.tags)
                    }else{
                        alert(value.message)
                    }
                    return value
                })
                this.isconfirm=true;
            },
            removeservice:function(n){
                this.tags.splice(n,1)
            },
            serviceSubmit: function() {
                //console.log(this)
                var data = {
                    hotel: this.id ||this.param,
                    method: this.method,
                    token: localStorage['token'],
                    services:this.speicalService,
                    tags:this.tagsId
                };
                console.log(data.tags)
                //console.log(data)
                var jqPromise = $.post(this.url, data);
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    if (value.code == 0) {
                        // window.location.href = 'activity.html?id='+that.param;
                        that.isconfirm=false;
                         that.$route.router.go({name:'activity',params:{id:that.param}})
                    } else {
                        alert(value.message)
                    }
                })
            }

           },
        route:{
            activate:function(transtition){
            	window.scrollTo(0,0);
                transtition.next()
            },
            canDeactivate:function(transition){
                if(this.isconfirm){
                    if(confirm('还未保存，确定退出？')){
                        transition.next()
                    }else{
                        transition.abort()
                    }
                }else{
                    transition.next()
                }
                
            },
            data: function() {
             this.param = this.$route.params.id;
             this.$dispatch('pageinfo','酒店服务');
              if (this.param) {
                this.method = 'amenserv_update_service';
                this.id = this.param;
                var jqPromise = $.post(this.url, {
                    method: 'amenserv_service',
                    token: localStorage['token'],
                    hotel: this.param
                });
                var realPromise = Promise.resolve(jqPromise),
                    that = this;
                realPromise.then(function(value) {
                    var value = JSON.parse(value);
                    that.id = value.data&&value.data.id || this.param;
                    that.tags=value.data&&value.data.tags||[];
                    that.speicalService = value.data&&value.data.services || [{
                        name: '',
                        hotel:'',
                        pic:'',
                        text:''
                    }];
                    that.speicalService.push({
                        name: '',
                        hotel:'',
                        pic:'',
                        text:''
                    })
                    return value;
                })
            }

        },
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/service.vue
// module id = 99
// module chunks = 0